import { app } from '../../app';
import { Controller } from './sp-company-user-label.controller';

app.component('spCompanyUserLabel', {
    bindings: {
        companyUserId: '<',
        displayName: '<',
        saaspassId: '<',
    },
    controller: Controller,
    templateUrl: require('./sp-company-user-label.html'),
});



// WEBPACK FOOTER //
// ./src/portal/components/sp-company-user-label/sp-company-user-label.component.js